export enum TaskStatus {
    NEW = 0,
    DONE = 1,
    NOT_DONE = 2
}
